import { MenuCategory } from './piece-menu.models';

/**
 * Sorts the categories by its ordering number.
 * @param a - First category
 * @param b - Second category
 */
export function sortCategories(a: MenuCategory, b: MenuCategory): number {
  const aVal = isDefined(a) && isDefined(a.order) ? a.order : Number.MAX_VALUE;
  const bVal = isDefined(b) && isDefined(b.order) ? b.order : Number.MAX_VALUE;
  return aVal - bVal;
}
